type CapturePoint = Parameters<ErrorConstructor['captureStackTrace']>[1]

export const capture = (error: Error, func: CapturePoint): void => Error.captureStackTrace && Error.captureStackTrace(error, func)

export const withCaptured = <E extends Error>(error: E, func: CapturePoint): E => {
    capture(error, func)
    return error
}

/**
 * Captures error so it appears to be yielded from the given function
 *
 * @param error Error to be thrown
 * @param func artificial error origin
 */
export const throwCaptured = (error: Error, func: CapturePoint): never => {
    capture(error, func)
    throw error
}
